import React from 'react'

import moment from 'moment'

import OrderActions from '../../actions/OrderActions.js'
import ParcelActions from '../../actions/ParcelActions.js'
import dbCodes from '../../../server/dbCodes.js'

import {Alert, Button, Colors, IconButton, Modal, H1, H4, S1, S2, P, ScrollView, PdfModal, Popup, ListItem, Badge, Card, Row, H6, Link, H3, H2, Stack, Spinner} from '../UI/index.js'
import CarrierLogo from '../parcels/CarrierLogo.js'
import {FormRow, FormStack, Input, Check, formSpacing} from '../UI/forms/index.js'
import {fromLabelCallback, printLabels} from '../labels/printLabels.js'
import _ from 'lodash'
import Languages from '@utils/Languages.js'

export default class OrderScanModal extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            modalIsOpen: false,
            warningNotToday: !!localStorage.getItem('warningNotToday'),
            barcode: '',
            order: null,
            collo: null,
            packaging: null,
            address: null,
            parcel: null,
            loading: false,
            message: '',
            warning: '',
            error: ''
        }

        this.successAudio = new Audio('../scan.wav')
        this.warningAudio = new Audio('../error.wav')
        this.errorAudio = new Audio('../error.wav')

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open() {
        this.setState({modalIsOpen: true}, () => {
            this.input.focus()
        })
    }

    close() {
        this.setState(this.initialState)
    }

    onSubmit(event) {
        event.preventDefault()
        const {barcode} = this.state

        let warning = ''

        this.setState({loading: true, order: null, packaging: null, parcel: null, warning: '', error: ''})

        const showParcel = (parcel) => {
            if (parcel.status === dbCodes.parcelStatus.geannuleerd()) {
                this.warningAudio.play()
                warning = 'Zending is geannuleerd.'
            } else {
                this.successAudio.play()
            }

            this.setState({barcode: '', loading: false, parcel, warning})
        }

        const parcelScan = () => {
            ParcelActions.scan(barcode, (err, parcel) => {
                if (parcel) {
                    showParcel(parcel)
                } else {
                    this.errorAudio.play()
                    this.setState({barcode: '', loading: false, error: `Geen resultaat voor barcode ${barcode}`})
                }
            })
        }

        const getBarcodeAddress = (order) => {
            const collo = _.find(order.colli, (collo) => collo.barcode === barcode)
            return order.addresses[collo?.deliveryAddressIndex ?? collo?.pickupAddressIndex]
        }

        OrderActions.findByBarcode(barcode, async (err, orders, packages) => {
            let id = orders?.[0]?._id
            let idsToScan = id ? [id] : []

            if (orders?.length > 1) {
                const isPickupDeliveryPair = orders.length === 2 && (() => {
                    const types = orders.map((order) => getBarcodeAddress(order)?.type)
                    return types.filter((type) => type === 'pickup').length === 1 && types.filter((type) => type === 'delivery').length === 1
                })()

                if (isPickupDeliveryPair) {
                    idsToScan = orders.toSorted((orderA, orderB) => {
                        const addressA = getBarcodeAddress(orderA)
                        const addressB = getBarcodeAddress(orderB)

                        const aNumber = addressA?.type === 'pickup' ? 1 : 2
                        const bNumber = addressB?.type === 'pickup' ? 1 : 2

                        return aNumber - bNumber
                    }).map((order) => order._id)
                } else {
                    const option = await this.popup.openOptions('Er zijn meerdere zendingen gevonden voor deze barcode', 'Selecteer de zending die je wilt scannen', orders.map((order) => {
                        const address = getBarcodeAddress(order)

                        return (
                            <ListItem key={order._id} onClick={() => this.popup.onClickOption({value: order._id})}>
                                <S1 style={{width: 100}}>{moment(order.date).format('YYYY-MM-DD')}</S1>
                                <P style={{flex: 2, marginLeft: 12}}>
                                    {address ?
                                        `${(address.isBusiness && address.name) ?
                                            address.name :
                                            `${address.street} ${address.nr}${address.addition}`}` :
                                        order.trackTrace
                                    }
                                </P>
                                <Badge style={{width: 'fit-content', marginLeft: 12}}>{dbCodes.status[order.status]}</Badge>
                            </ListItem>
                        )
                    }))
                    if (!option) return

                    id = option.value
                    idsToScan = id ? [id] : []
                }
            }

            if (!orders?.length && packages?.length) {
                id = packages[0]._id

                if (packages.length > 1) {
                    const option = await this.popup.openOptions('Er zijn meerdere verpakkingen gevonden voor deze barcode', 'Selecteer de verpakking die je wilt scannen', packages.map((packaging) => {
                        return (
                            <ListItem key={packaging._id} onClick={() => this.popup.onClickOption({value: packaging._id})}>
                                <S1 style={{width: 100}}>{moment(packaging.events[packaging.events.length - 1].timestamp).format('YYYY-MM-DD')}</S1>
                                <P style={{flex: 2, marginLeft: 12}}>
                                    {packaging.barcode}
                                </P>
                                <Badge style={{width: 'fit-content', marginLeft: 12}}>{dbCodes.packagingStatus[packaging.status]}</Badge>
                            </ListItem>
                        )
                    }))
                    if (!option) return

                    id = option.value
                }

                idsToScan = id ? [id] : []
            }

            const handleScanResult = (order, packaging) => {
                if (order) {
                    const {user} = this.props
                    if (user?.reseller !== order.reseller) {
                        parcelScan()
                        return
                    }

                    const collo = _.find(order.colli, (collo) => collo.barcode === barcode)

                    const address = order.addresses[collo.deliveryAddressIndex ?? collo.pickupAddressIndex]

                    let dateText = moment(order.date).locale('nl').format('dddd D MMMM')

                    if (order.date === moment().format('YYYY-MM-DD')) {
                        dateText = 'vandaag'
                    } else if (order.date === moment().add(1, 'day').format('YYYY-MM-DD')) {
                        dateText = 'morgen'
                    }

                    if (order.status === dbCodes.status.inBewaring()) {
                        warning = `Rit is in bewaring tot ${moment(order.date).locale('nl').format('D MMMM')}.`
                        this.warningAudio.play()
                    } else if (order.status === dbCodes.status.afgerond() || order.status === dbCodes.status.nietAfgerond() || order.status === dbCodes.status.onderweg() || order.status === dbCodes.status.geannuleerd()) {
                        warning = `Rit heeft status: ${dbCodes.status[order.status]}.`
                        this.warningAudio.play()
                    } else if (order.date !== moment().format('YYYY-MM-DD') && this.state.warningNotToday) {
                        warning = `Rit voor ${dateText}.`
                        this.warningAudio.play()
                    } else {
                        this.successAudio.play()
                    }

                    if ((order.status === dbCodes.status.verwacht() || order.status === dbCodes.status.inSortering() || order.status === dbCodes.status.gereed() || order.status === dbCodes.status.onderweg())) {
                        this.setState({showRouteDetails: true})
                    } else {
                        this.setState({showRouteDetails: false})
                    }

                    this.setState({barcode: '', loading: false, order, collo, address, warning})
                } else if (packaging) {
                    this.successAudio.play()

                    this.setState({barcode: '', loading: false, packaging})
                } else {
                    this.errorAudio.play()
                    this.setState({barcode: '', loading: false, error: `Geen resultaat voor barcode ${barcode}`})
                }
            }

            if (idsToScan.length) {
                if (idsToScan.length > 1) {
                    let scannedOrder = null
                    let scannedPackaging = null

                    for (const id of idsToScan) {
                        const {order, packaging} = await new Promise((resolve) => {
                            OrderActions.scan({id, barcode}, (err, order, packaging) => {
                                resolve({order, packaging})
                            })
                        })

                        if (order) {
                            scannedOrder = order
                        }

                        if (packaging) {
                            scannedPackaging = packaging
                        }
                    }

                    handleScanResult(scannedOrder, scannedPackaging)
                } else {
                    const isPickupMatch = orders?.length === 1 && getBarcodeAddress(orders[0])?.type === 'pickup'

                    OrderActions.scan({id: idsToScan[0], barcode}, (err, order, packaging) => {
                        if (isPickupMatch) {
                            ParcelActions.scan(barcode, (err, parcel) => {
                                if (parcel) {
                                    showParcel(parcel)
                                } else {
                                    handleScanResult(order, packaging)
                                }
                            })
                        } else {
                            handleScanResult(order, packaging)
                        }
                    })
                }
            } else {
                parcelScan()
            }
        })
    }

    onClickGotoTrackTrace() {
        const {order, parcel} = this.state

        if (order) {
            window.open(`/track&trace/${order.trackTrace}`)
        } else if (parcel) {
            window.open(parcel.trackTrace)
        }
    }

    onClickShowOnMap() {
        const {order} = this.state
        const {filteredOrders} = this.props

        if (order) {
            if (filteredOrders[order._id]) {
                this.close()
                OrderActions.setView('routes', true)
                OrderActions.setSelected([order._id])
            } else {
                this.setState({error: 'Deze rit kan niet worden weergeven op de kaart omdat deze niet in de huidige selectie zit, pas de datumselectie of filters aan.'})
            }
        }
    }

    onClickPrintLabels() {
        const {order, collo, parcel} = this.state
        const {printerPageSize} = this.props

        printLabels({
            ids: [order?._id || parcel?._id],
            printerPageSize,
            printPopup: this.printPopup,
            pdfModal: this.pdfModal,
            print: (ids, nrOfEmptyLabels) => {
                if (order) {
                    return fromLabelCallback((callback) => OrderActions.printLabels([order._id], nrOfEmptyLabels, null, collo?.index, callback))
                } else if (parcel) {
                    return fromLabelCallback((callback) => ParcelActions.printLabels([parcel._id], nrOfEmptyLabels, callback))
                }

                // Nothing scanned: the popup keeps loading, as before
                return new Promise(() => {})
            },
            itemName: 'ritten'
        })
    }

    render() {
        const {modalIsOpen, warningNotToday, barcode, order, collo, address, packaging, parcel, showRouteDetails, loading, message, warning, error} = this.state
        const {user, users, routes, carriers, partners, reseller, history} = this.props

        const {statusColor, status, subStatus} = Colors.orderStatusColor(order)

        // A copy we returned to the partner that sent us the order is handled by that partner again
        const isReturnedToPartner = !!order?.partnerId && !!order.retourId && order.retourId !== order._id
        const carrierPartnerId = order?.handledBy === 'partner' || isReturnedToPartner ? order.partnerId : null

        let partnerScanColor = null

        if (carrierPartnerId) {
            const partnerSettings = reseller.settings.outgoingPartners?.find((settings) => settings._id === carrierPartnerId)

            if (partnerSettings?.useCustomScanColor) {
                partnerScanColor = partnerSettings.customScanColor || ''
            }
        }

        const parcelCarrier = parcel && carriers.find((carrier) => carrier.name === parcel.carrier)

        // With partner connections, always show who executes the order (like when scanning parcels)
        const carrierLogo = order && Object.keys(partners || {}).length > 0 ?
            (carrierPartnerId ? partners[carrierPartnerId]?.logo : reseller.settings.logo) :
            ''

        return (
            <Modal show={modalIsOpen} onClose={this.close.bind(this)}>
                <div style={{display: 'flex', alignItems: 'center', marginBottom: 12}}>
                    <H4>Scannen</H4>

                    <div style={{flex: 1}} />

                    <IconButton
                        onClick={this.onClickPrintLabels.bind(this)}
                        disabled={!order && !parcel}
                    >
                        <i className='mdi mdi-printer' />
                    </IconButton>

                    <div style={{flex: 1}} />

                    <IconButton onClick={this.close.bind(this)}>
                        <i style={{color: Colors.buttonSolid}} className='mdi mdi-close' />
                    </IconButton>
                </div>

                <FormStack>
                    <form onSubmit={this.onSubmit.bind(this)} style={{display: 'flex'}}>
                        <Input
                            label='Barcode'
                            value={barcode}
                            onChange={(event) => {
                                this.setState({
                                    barcode: event.target.value
                                        .replace(/^\][A-Za-z][0-9]/, '') // Remove AIM ID: e.g. ]C1 for Code 128
                                        .toUpperCase()
                                        .trim()
                                })
                            }}
                            ref={(ref) => this.input = ref}
                        />

                        <Button style={{visibility: 'hidden', position: 'absolute'}} type='submit' />
                    </form>

                    <Check
                        label='Waarschuwing indien rit niet voor vandaag'
                        checked={warningNotToday}
                        onChange={(event) => {
                            localStorage.setItem('warningNotToday', event.target.checked ? 'true' : '')
                            this.setState({warningNotToday: event.target.checked})
                        }}
                    />
                </FormStack>
                <br />

                {loading &&
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: 330}}>
                        <Spinner />
                    </div>
                }

                {!loading && !order && !packaging && !parcel &&
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <i style={{fontSize: 250, color: Colors.grey20}} className='mdi mdi-barcode-scan' />
                    </div>
                }

                {message && <Alert style={{marginBottom: 12}} variant='success'>{message}</Alert>}
                {warning && <Alert style={{marginBottom: 12}} variant='warning'>{warning}</Alert>}
                {error && <Alert style={{marginBottom: 12}} variant='danger'>{error}</Alert>}

                {order && user?.reseller !== order?.reseller &&
                    <Alert style={{marginBottom: 12}} variant='danger'>{`Sorteerfout, pakket bestemd voor ${order?.reseller}`}</Alert>
                }

                {order && user?.reseller === order?.reseller &&
                    <>
                        <Card style={{marginBottom: 24}}>
                            <Row style={{alignItems: 'center'}}>
                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <i style={{fontSize: 16, marginRight: 12}} className='mdi mdi-package-variant-closed' />
                                    <P>{`Collo ${collo.index + 1} van ${order.colli.length} (${collo.barcode})`}</P>
                                </Row>

                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <Stack style={{flex: 1, justifyContent: 'center', alignItems: 'center', background: statusColor, marginBottom: 12, height: 42}}>
                                        {subStatus && subStatus !== dbCodes.status[dbCodes.status.geannuleerd()] ?
                                            <S1 ellipsis>{`${subStatus}${Colors.orderRetourSuffix(order)}`}</S1> :
                                            <S1 ellipsis>{`${status}${Colors.orderRetourSuffix(order)}`}</S1>
                                        }
                                    </Stack>
                                </Row>
                            </Row>

                            <Row style={{alignItems: 'center'}}>
                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <i style={{fontSize: 16, marginRight: 12}} className='mdi mdi-web' />
                                    {order.noTrackTrace ?
                                        <S1>{order.trackTrace}</S1> :
                                        <Link onClick={() => this.onClickGotoTrackTrace()}>{order.trackTrace}</Link>
                                    }
                                </Row>

                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, columnGap: formSpacing.columnGap, minWidth: 'auto'}}>
                                    <Button
                                        style={{width: '100%'}}
                                        variant='outline'
                                        label={Languages.orderInfo['NL']}
                                        icon='mdi mdi-eye'
                                        onClick={() => {
                                            history.push('/empty')
                                            setTimeout(() => history.replace('/planning', {orderId: order._id, fromScan: true}), 1)
                                        }}
                                    />

                                    {!!address.position?.lat &&
                                        <Button
                                            style={{width: '100%'}}
                                            variant='outline'
                                            label={Languages.map['NL']}
                                            icon='mdi mdi-map'
                                            tooltip='Toon rit op kaart'
                                            onClick={this.onClickShowOnMap.bind(this)}
                                        />
                                    }
                                </Row>
                            </Row>
                        </Card>

                        <Card style={{marginBottom: 12, padding: formSpacing.inset}}>
                            {(order.type === 'parcelDelivery' || order.type === 'parcelPickup') && order.handledBy === 'reseller' && reseller.settings.parcels.carriers?.[order.reseller]?.useCustomScanColor && (
                                <P
                                    style={{
                                        height: 36,
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 4,
                                        marginBottom: 48,
                                        backgroundColor: reseller.settings.parcels.carriers?.[order.reseller]?.customScanColor || '',
                                        color: Colors.isDarkBackground(reseller.settings.parcels.carriers?.[order.reseller]?.customScanColor || '#ffffff') ? 'white' : 'black'
                                    }}
                                >
                                    {reseller.settings?.accountName || reseller.name}
                                </P>
                            )}

                            {partnerScanColor !== null && (
                                <P
                                    style={{
                                        height: 36,
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 4,
                                        marginBottom: 48,
                                        backgroundColor: partnerScanColor,
                                        color: Colors.isDarkBackground(partnerScanColor || '#ffffff') ? 'white' : 'black'
                                    }}
                                >
                                    {partners?.[carrierPartnerId]?.name || ''}
                                </P>
                            )}
                            <Row style={{marginBottom: 12}}>

                                <Row style={{flex: 1, paddingRight: 6, flexDirection: 'column', alignItems: 'center', marginRight: 12, paddingLeft: 0}}>
                                    {showRouteDetails &&
                                        <>
                                            <H2 style={{color: order.routeColor || routes[order.routeId]?.color || Colors.textDark, marginBottom: 6, fontWeight: 400, fontSize: 36}}>
                                                {`${order.routeName || routes[order.routeId]?.name || 'Geen route'} ${order.routeStartTime || routes[order.routeId]?.plannedStartTime ? `(${order.routeStartTime || routes[order.routeId]?.plannedStartTime})` : ''}`}
                                            </H2>
                                            <H3 style={{marginBottom: 36, color: order.routeColor || routes[order.routeId]?.color || Colors.textDark, fontWeight: 400}}>
                                                {users[order.routeMessengerId || routes[order.routeId]?.messengerId]?.name || ''}
                                            </H3>
                                            <H1 style={{marginBottom: 30, color: order.routeColor || routes[order.routeId]?.color || Colors.textDark}}>
                                                {address.stopNumber ? address.stopNumber : '-'}
                                            </H1>
                                        </>
                                    }
                                </Row>

                                <Row style={{flex: 1, paddingLeft: 6, flexDirection: 'column', minWidth: 0, paddingRight: 0}}>
                                    {carrierLogo &&
                                        <img style={{objectFit: 'contain', objectPosition: 'left', height: 40, maxWidth: '100%', marginLeft: 12, marginBottom: 12}} src={carrierLogo} />
                                    }

                                    <div style={{display: 'flex'}}>
                                        <div style={{flex: 1, marginLeft: 12, minWidth: 0}}>
                                            <S2>{`${address.type === 'pickup' ? 'Ophaaladres' : 'Bezorgadres'}`}</S2>

                                            <P>{`${address.name || ''}`}</P>
                                            <P>{address.attention}</P>
                                            <P>{`${address.street} ${address.nr}${address.addition}`}</P>
                                            <P>{address.street2}</P>
                                            <P>{`${address.postalCode} ${address.city}`}</P>
                                            <P style={{whiteSpace: 'pre-line'}}>{address.instructions}</P>

                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                {address.gpsRequired &&
                                                    <i style={{fontSize: 20, marginRight: 3}} className='mdi mdi-map-marker' />
                                                }
                                                {address.signatureRequired &&
                                                    <i style={{fontSize: 20, marginRight: 3}} className='mdi mdi-fountain-pen-tip' />
                                                }
                                                {address.nameRequired && !address.signatureRequired &&
                                                    <i style={{fontSize: 20, marginRight: 3}} className='mdi mdi-signature-text' />
                                                }
                                                {address.statedAddressOnly &&
                                                    <i style={{fontSize: 20, marginRight: 3}} className='mdi mdi-home' />
                                                }
                                                {address.mailboxDelivery &&
                                                    <i style={{fontSize: 20, marginRight: 3}} className='mdi mdi-mailbox-open-up' />
                                                }
                                                {address.refrigerated &&
                                                    <i style={{fontSize: 20, marginRight: 3}} className='mdi mdi-snowflake' />
                                                }
                                                {address.scanRequired &&
                                                    <i style={{fontSize: 20, marginRight: 3}} className='mdi mdi-barcode-scan' />
                                                }
                                                {address.imageRequired &&
                                                    <i style={{fontSize: 20}} className='mdi mdi-camera' />
                                                }
                                                {address.minimumAge &&
                                                    <div style={{fontSize: 14, fontWeight: 500, marginRight: 6}}>{`${address.minimumAge}+`}</div>
                                                }
                                                {address.idCheck &&
                                                    <i style={{fontSize: 20, marginRight: 3}} className='mdi mdi-card-account-details-outline' />
                                                }
                                                {address.verificationCode &&
                                                    <i style={{fontSize: 20}} className='mdi mdi-shield-key-outline' />
                                                }
                                            </div>
                                        </div>

                                        <div style={{flex: 1}}>
                                            <div style={{display: 'flex'}}>
                                                {address.hasArrived && address.timeOfArrival &&
                                                    <div style={{flex: 1}}>
                                                        <S2>Aankomsttijd</S2>
                                                        <P>{`${address.timeOfArrival.replace(':', '.')} uur`}</P>
                                                    </div>
                                                }

                                                {!address.hasArrived && address.estimatedTimeOfArrival &&
                                                    <div style={{flex: 1}}>
                                                        <S2>Verwachte aankomsttijd</S2>
                                                        <P>{`${address.estimatedTimeOfArrival.replace(':', '.')} uur`}</P>
                                                    </div>
                                                }

                                                {!address.hasArrived && !address.estimatedTimeOfArrival &&
                                                    <div style={{flex: 1}}>
                                                        <S2>Tijdvak</S2>
                                                        <P>{`${address.startTime.replace(':', '.')} - ${address.endTime.replace(':', '.')} uur`}</P>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </Row>

                            <FormStack>
                                <FormRow>
                                    <Input
                                        label='Datum'
                                        value={moment(order.date).format('DD-MM-YYYY')}
                                        readOnly
                                    />
                                    <Input
                                        label='Referentie'
                                        value={order.reference}
                                        readOnly
                                    />
                                </FormRow>

                                <FormRow>
                                    <Input
                                        label='Afzender'
                                        value={`${order.senderAddress?.name || ''}${order.senderAddress?.name ? ` (${order.customerAddress?.name})` : order.customerAddress?.name}`}
                                        readOnly
                                    />
                                    <Input
                                        label='Opmerkingen'
                                        value={order.notes}
                                        readOnly
                                    />
                                </FormRow>
                            </FormStack>
                        </Card>

                        <H6 style={{marginBottom: 12}}>Historie</H6>

                        <ScrollView style={{maxHeight: 250}}>
                            {[...order.history].reverse().map((entry, index) => {
                                return (
                                    <Row key={`history${index}`} style={{marginBottom: 3, flexShrink: 0}}>

                                        <i className='mdi mdi-circle-small' style={{marginRight: 6, fontSize: 16, color: Colors.grey60}} />

                                        <Row style={{paddingLeft: 6, paddingRight: 6, flex: 1, flexDirection: 'column', minWidth: 'auto'}}>

                                            <Row style={{alignItems: 'center'}}>
                                                {entry.type === 'invoice' ?
                                                    <Link onClick={() => history.push('/facturatie', {invoiceId: entry.invoiceId})}>{entry.description}</Link> :
                                                    <P>{entry.description || (typeof entry.status === 'number' ? dbCodes.status[entry.status] : '')}</P>
                                                }
                                            </Row>

                                            {entry.colli?.length > 0 &&
                                                <>
                                                    {entry.colli.map((collo, index) => {
                                                        const {status, reason, statusColor} = Colors.colloStatusColor(entry.type, collo)
                                                        const isScanned = entry?.scanned?.findIndex((barcode) => barcode === collo.barcode) > -1

                                                        return (
                                                            <Row key={`collo${index}`}>
                                                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                                                    <i className='mdi mdi-circle' style={{marginRight: 12, marginTop: 4, fontSize: 10, color: statusColor}} />
                                                                    {isScanned && <i className='mdi mdi-barcode-scan ' style={{marginRight: 6}} />}
                                                                    <P>{`${reason || status}${collo.reasonSpecification ? ` - ${collo.reasonSpecification}` : ''}: Collo ${collo.index + 1}${collo.barcode ? ` - ${collo.barcode}` : ''}`}</P>
                                                                </Row>
                                                            </Row>
                                                        )
                                                    })}
                                                </>
                                            }

                                            {entry.comment &&
                                                <S2 style={{}}>{entry.comment}</S2>
                                            }
                                        </Row>

                                        <Row style={{paddingLeft: 6, paddingRight: 6, width: 200, minWidth: 'auto'}}>
                                            <S2>{`${entry.who} | ${entry.timestamp ? moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss') : entry.time}`}</S2>
                                        </Row>
                                    </Row>
                                )
                            })}
                        </ScrollView>
                    </>
                }

                {packaging &&
                    <>
                        <Card style={{marginBottom: 24}}>
                            <Row style={{alignItems: 'center'}}>
                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <i style={{fontSize: 16, marginRight: 12}} className='mdi mdi-package-variant-closed' />
                                    <P>{packaging.barcode}</P>
                                </Row>

                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', background: statusColor, height: 42, marginBottom: 6}}>
                                        <S1>{dbCodes.packagingStatus[packaging.status]}</S1>
                                    </div>
                                </Row>
                            </Row>
                        </Card>

                        <H6 style={{marginBottom: 12}}>Historie</H6>

                        <ScrollView style={{maxHeight: 250}}>
                            {[...packaging.events].reverse().map((event, index) => {
                                return (
                                    <Row key={`history${index}`} style={{marginBottom: 3, flexShrink: 0}}>

                                        <i className='mdi mdi-circle-small' style={{marginRight: 6, fontSize: 16, color: Colors.grey60}} />

                                        <Row style={{paddingLeft: 6, paddingRight: 6, flex: 1, flexDirection: 'column', minWidth: 'auto'}}>

                                            <Row style={{alignItems: 'center'}}>
                                                <P>{event.description || dbCodes.packagingStatus[event.status]}</P>
                                            </Row>
                                        </Row>

                                        <Row style={{paddingLeft: 6, paddingRight: 6, width: 200, minWidth: 'auto'}}>
                                            <S2>{`${event.who || ''} | ${moment(event.timestamp).format('DD-MM-YYYY HH:mm:ss')}`}</S2>
                                        </Row>
                                    </Row>
                                )
                            })}
                        </ScrollView>
                    </>
                }

                {parcel &&
                    <>
                        <Card style={{marginBottom: 24}}>
                            <Row style={{alignItems: 'center'}}>
                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <i style={{fontSize: 16, marginRight: 12}} className='mdi mdi-web' />
                                    <Link onClick={() => this.onClickGotoTrackTrace()}>{parcel.trackTrace}</Link>
                                </Row>

                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <Button
                                        variant='outline'
                                        label={Languages.parcelInfo['NL']}
                                        icon='mdi mdi-eye'
                                        style={{width: '100%'}}
                                        onClick={() => {
                                            history.push('/empty')
                                            setTimeout(() => history.replace('/zendingen', {parcelId: parcel._id}), 1)
                                        }}
                                    />
                                </Row>
                            </Row>
                        </Card>

                        <Card style={{marginBottom: 12, padding: formSpacing.inset}}>
                            <Row>
                                <P
                                    style={{
                                        height: 36,
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 4,
                                        marginBottom: 48,
                                        backgroundColor: reseller.settings.parcels.carriers?.[parcel.carrier]?.useCustomScanColor ? (reseller.settings.parcels.carriers?.[parcel.carrier]?.customScanColor || '') : '',
                                        ...(reseller.settings.parcels.carriers?.[parcel.carrier]?.useCustomScanColor && {
                                            color: Colors.isDarkBackground(reseller.settings.parcels.carriers?.[parcel.carrier]?.customScanColor || '#ffffff') ? 'white' : 'black'
                                        })
                                    }}
                                >
                                    {parcelCarrier ? `${parcelCarrier.displayName}${parcelCarrier.platform ? `-${parcelCarrier.platform}` : ''}` : parcel.carrier}
                                </P>
                            </Row>
                            <Row style={{marginBottom: 12}}>
                                <Row style={{flex: 1, paddingRight: 6, flexDirection: 'column', alignItems: 'center', paddingLeft: 0}}>
                                    <CarrierLogo
                                        size={100}
                                        carriers={carriers}
                                        value={parcel.carrier || parcel.reseller}
                                        options={parcel.options}
                                    />
                                </Row>

                                <Row style={{flex: 1, paddingLeft: 6, flexDirection: 'column', marginBottom: 12, paddingRight: 0}}>
                                    <S2>Bezorgadres</S2>
                                    <P>{parcel.address.name}</P>
                                    <P>{parcel.address.attention}</P>
                                    <P>{`${parcel.address.street} ${parcel.address.nr}${parcel.address.addition}`}</P>
                                    <P>{parcel.address.street2}</P>
                                    <P>{`${parcel.address.postalCode} ${parcel.address.city}`}</P>
                                    <P>{parcel.address.country}</P>

                                    <P style={{marginTop: 12}}>{parcel.address.email}</P>
                                    <P>{parcel.address.phone}</P>
                                </Row>
                            </Row>

                            <FormStack>
                                <FormRow>
                                    <Input
                                        label='Datum'
                                        value={moment(parcel.date).format('DD-MM-YYYY')}
                                        readOnly
                                    />
                                    <Input
                                        label='Referentie'
                                        value={parcel.reference}
                                        readOnly
                                    />
                                </FormRow>

                                <FormRow>
                                    <Input
                                        label='Afzender'
                                        value={parcel.senderAddress?.name}
                                        readOnly
                                    />
                                    <div style={{flex: 1}} />
                                </FormRow>
                            </FormStack>
                        </Card>

                        <H6 style={{marginBottom: 12}}>Historie</H6>

                        <ScrollView style={{maxHeight: 250}}>
                            {[...parcel.history].reverse().map((entry, index) => {
                                return (
                                    <div key={`history${index}`} style={{display: 'flex', alignItems: 'center', padding: 5}}>
                                        <div style={{height: 15, width: 15, borderRadius: '50%', marginRight: 15, background: !entry.status || entry.status === 1 ? Colors.grey20 : Colors.parcelStatus[entry.status]}} />
                                        <div style={{flex: 1}}>
                                            <P>{entry.description || (typeof entry.status === 'number' ? dbCodes.parcelStatus[entry.status] : '')}</P>
                                        </div>
                                        <S2 style={{marginRight: 15}}>{`${entry.who} | ${entry.timestamp ? moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss') : entry.time}`}</S2>
                                    </div>
                                )
                            })}
                        </ScrollView>
                    </>
                }

                <Popup ref={(ref) => this.printPopup = ref} />
                <PdfModal ref={(ref) => this.pdfModal = ref} />
                <Popup ref={(ref) => this.popup = ref} />
            </Modal>
        )
    }
}
